export default "__VITE_ASSET__b8be803d__"